import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Log } from 'src/app/_models/log';

@Injectable({
  providedIn: 'root'
})
export class LogService {

  constructor(private httpClient: HttpClient) { }

  getLogPorData(dtIni: Date, dtFim: Date): Observable<Log[]> {
    return this.httpClient.get<Log[]>(`${environment.apiUrl}/log/get-log-por-data/${dtIni.toDateString()}/${dtFim.toDateString()}`);
  }
  
}
